import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'kb-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <div class="kb-grain"></div>
    <router-outlet />
  `
})
export class AppComponent {}
